import { render, staticRenderFns } from "./agencies.vue?vue&type=template&id=4d208b3e&scoped=true&"
import script from "./agencies.vue?vue&type=script&lang=ts&"
export * from "./agencies.vue?vue&type=script&lang=ts&"
import style1 from "./agencies.vue?vue&type=style&index=1&id=4d208b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d208b3e",
  null
  
)

export default component.exports